import { render, staticRenderFns } from "./ProfitReport.vue?vue&type=template&id=04ea131d&scoped=true"
import script from "./ProfitReport.vue?vue&type=script&lang=js"
export * from "./ProfitReport.vue?vue&type=script&lang=js"
import style0 from "./ProfitReport.vue?vue&type=style&index=0&id=04ea131d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea131d",
  null
  
)

export default component.exports